import { Divider, ListItemIcon, ListItemButton, ListItemText } from "@mui/material";

function SidebarList({ items }) {
  return items.map(({ onClick, icon, text, divider, ...other }, i) =>
    divider ? (
      <Divider key={i} />
    ) : (
      <ListItemButton key={text || i} onClick={onClick} {...other}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    )
  );
}

export default SidebarList;
